import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuid4 } from 'uuid';
export const initialState = {
    snackbarQueue: [],
};
export const SnackbarSlice = createSlice({
    name: 'snackbarSlice',
    initialState,
    reducers: {
        enqueueSnackbar: (state, action) => {
            const { id = uuid4(), severity = 'error', autoHideDuration = 5000, anchorOrigin = { vertical: 'top', horizontal: 'right' }, ...rest } = action.payload;
            const snackbar = {
                id,
                severity,
                anchorOrigin,
                autoHideDuration,
                ...rest,
            };
            state.snackbarQueue.push(snackbar);
        },
        dequeueSnackbarWithId: (state, action) => {
            state.snackbarQueue = state.snackbarQueue.filter((snackbar) => snackbar.id !== action.payload);
        },
    },
});
export const SnackbarActions = {
    ...SnackbarSlice.actions,
};
export const SnackbarReducer = SnackbarSlice.reducer;
